const rawAcknowledgementsFlag = process.env.NEXT_PUBLIC_FEATURE_ACKNOWLEDGEMENTS;
const rawDashboardAssistantFlag = process.env.NEXT_PUBLIC_FEATURE_DASHBOARD_ASSISTANT;

function parseBooleanFlag(value: string | undefined | null): boolean {
  if (!value) return false;
  const normalized = value.trim().toLowerCase();
  return normalized === '1' || normalized === 'true' || normalized === 'yes';
}

export const ACKNOWLEDGEMENTS_ENABLED = parseBooleanFlag(rawAcknowledgementsFlag);
export const DASHBOARD_ASSISTANT_ENABLED = parseBooleanFlag(rawDashboardAssistantFlag);
